// extracted by mini-css-extract-plugin
module.exports = {"dateButton":"BillModuleDatesButton_dateButton__AcSxZ","date":"BillModuleDatesButton_date__0Kmyh","label":"BillModuleDatesButton_label__vPYtu"};